
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const [{createUI, installThemeToggle, installHashImportBanner, runTestCasesWithTimeout}, {createGameUI, loadGame, makeClient, stripModuleSyntax, prepareGameFile}] = await Promise.all([import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("runTestCasesWithTimeout" in module)) throw new SyntaxError(`export 'runTestCasesWithTimeout' not found`);
  return module;
}), import("./lib/bgio.js").then((module) => {
  if (!("createGameUI" in module)) throw new SyntaxError(`export 'createGameUI' not found`);
  if (!("loadGame" in module)) throw new SyntaxError(`export 'loadGame' not found`);
  if (!("makeClient" in module)) throw new SyntaxError(`export 'makeClient' not found`);
  if (!("stripModuleSyntax" in module)) throw new SyntaxError(`export 'stripModuleSyntax' not found`);
  if (!("prepareGameFile" in module)) throw new SyntaxError(`export 'prepareGameFile' not found`);
  return module;
})]);
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, testReport } = createUI({ html });
const { gameBoard, mountEditor, mountGameSection, sectionLabel } = createGameUI({ html });
const starter = prepareGameFile(3);
return {createUI,installThemeToggle,installHashImportBanner,runTestCasesWithTimeout,createGameUI,loadGame,makeClient,stripModuleSyntax,prepareGameFile,codeEditor,ok,err,hint,testReport,gameBoard,mountEditor,mountGameSection,sectionLabel,starter};
},
    inputs: ["html","display"],
    outputs: ["createUI","installThemeToggle","installHashImportBanner","runTestCasesWithTimeout","createGameUI","loadGame","makeClient","stripModuleSyntax","prepareGameFile","codeEditor","ok","err","hint","testReport","gameBoard","mountEditor","mountGameSection","sectionLabel","starter"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-3`),
    expanded: [],
    variables: []
  },
  {
    id: 3,
    body: (codeEditor,starter,html,loadGame,err,hint,testReport,makeClient,ok,stripModuleSyntax,runTestCasesWithTimeout,gameBoard,mountEditor,mountGameSection,sectionLabel) => {
const editor = codeEditor("bgio:game", { value: starter, label: "Deine Datei: TicTacToe.js" });
const isDrawSlot = html`<div></div>`;
const isVictorySlot = html`<div></div>`;
const endIfSlot = html`<div></div>`;
const boardSlot = html`<div></div>`;
const feedbackSlot = html`<div></div>`;

const DRAW_CASES = [
  [[["0", "1", "0", "1", "0", "1", "0", "1", "0"]], true],   // voll
  [[[null, "1", "0", "1", "0", "1", "0", "1", "0"]], false], // erstes Feld leer
  [[["0", "1", "0", "1", null, "1", "0", "1", "0"]], false], // Feld in der Mitte leer
  [[["0", "1", "0", "1", "0", "1", "0", "1", null]], false], // letztes Feld leer
  [[[null, null, null, null, null, null, null, null, null]], false], // leer
  [[["1", "1", "1", "0", "0", "0", "1", "0", "1"]], true]    // voll
];
const VICTORY_CASES = [
  [[["0", "0", "0", null, "1", "1", null, null, null]], "0"],  // obere Zeile
  [[["1", "1", null, "0", "0", "0", null, null, "1"]], "0"],   // mittlere Zeile
  [[[null, null, null, "0", "0", null, "1", "1", "1"]], "1"],  // untere Zeile (+ leere Zeile davor)
  [[["1", "0", null, "1", "0", null, "1", null, null]], "1"],  // linke Spalte
  [[["1", "0", null, null, "0", "1", "1", "0", null]], "0"],   // mittlere Spalte
  [[["0", null, "1", "0", null, "1", null, null, "1"]], "1"],  // rechte Spalte
  [[["0", "1", null, "1", "0", null, null, null, "0"]], "0"],  // Diagonale
  [[["0", "0", "1", null, "1", null, "1", null, null]], "1"],  // Gegendiagonale
  [[["0", "1", "0", "1", "0", "1", "1", "0", "1"]], null],     // voll, kein Gewinner
  [[[null, null, null, null, null, null, null, null, null]], null] // leer
];
// endIf bekommt (wie ein Move) ein Objekt mit `G` und gibt den Spielausgang
// zurück. Erwartet: { winner: "0"/"1" } bei Sieg, { draw: true } bei voll/kein
// Sieger, und null (oder gar nichts) solange das Spiel weiterläuft.
const ENDIF_CASES = [
  [[{ G: { cells: ["0", "0", "0", null, "1", "1", null, null, null] } }], { winner: "0" }], // obere Zeile -> Sieg 0
  [[{ G: { cells: ["1", "0", null, "1", "0", null, "1", null, null] } }], { winner: "1" }], // linke Spalte -> Sieg 1
  [[{ G: { cells: ["0", "1", null, "1", "0", null, null, null, "0"] } }], { winner: "0" }], // Diagonale -> Sieg 0
  [[{ G: { cells: ["0", "0", "0", "1", "1", "0", "1", "0", "1"] } }], { winner: "0" }],      // volles Feld, Sieg im letzten Zug -> Sieg schlägt Unentschieden
  [[{ G: { cells: ["0", "1", "0", "1", "0", "1", "1", "0", "1"] } }], { draw: true }],       // voll, kein Sieger -> Unentschieden
  [[{ G: { cells: [null, null, null, null, null, null, null, null, null] } }], null],        // leer -> läuft weiter
  [[{ G: { cells: ["0", "1", null, null, "0", null, null, null, "1"] } }], null]             // teils gefüllt, kein Sieger -> läuft weiter
];

// endIf ist eine Methode auf dem TicTacToe-Objekt (kein Top-Level-Name), daher
// laden wir das Spiel und rufen game.endIf direkt auf — statt des Worker-Runners,
// der nur globale Funktionen wie isDraw/isVictory findet.
function endIfReport(code) {
  let game;
  try { game = loadGame(code); }
  catch (e) { return err(html`Dein Code lässt sich nicht ausführen: ${e.message}`); }
  if (!game || typeof game.endIf !== "function")
    return hint(html`Schreib die <code>endIf</code>-Funktion.`);
  const results = ENDIF_CASES.map(([args, expected]) => {
    let actual, error;
    try { actual = game.endIf(...args); }
    catch (e) { error = e.message; }
    // null bedeutet "läuft weiter" — endIf darf dafür null ODER nichts (undefined)
    // zurückgeben. Den Gewinner vergleichen wir als String "0"/"1" (so wie isVictory
    // ihn liefert und die Übung unten ihn prüft).
    const passed = !error && (
      expected === null
        ? actual == null
        : actual != null && typeof actual === "object" &&
          (expected.draw ? actual.draw === true : actual.winner === expected.winner)
    );
    return { args, expected, actual: actual ?? null, passed, error };
  });
  return testReport({ error: null, results }, "endIf", { summaryOnly: true });
}

function capstone(code) {
  try {
    const game = loadGame(code);
    const winClient = makeClient(game);
    if (!(winClient.getState() && winClient.getState().G && Array.isArray(winClient.getState().G.cells)))
      throw new Error("setup gibt noch kein { cells: [...] } zurück (Kapitel 1).");
    for (const i of [0, 3, 1, 4, 2]) winClient.moves.clickCell(i);
    const go1 = winClient.getState().ctx.gameover;
    const wonByZero = go1 && go1.winner === "0";

    const drawClient = makeClient(game);
    for (const i of [0, 1, 2, 4, 3, 5, 7, 6, 8]) drawClient.moves.clickCell(i);
    const go2 = drawClient.getState().ctx.gameover;
    const drew = go2 && go2.draw === true;

    if (!wonByZero)
      return err(html`Drei in einer Reihe sollten das Spiel beenden — prüf <code>isVictory</code> und ob <code>endIf</code> <code>{ winner: ... }</code> zurückgibt.`);
    if (!drew)
      return err(html`Ein volles Feld ohne Gewinner sollte unentschieden enden — prüf <code>isDraw</code> und ob <code>endIf</code> <code>{ draw: true }</code> zurückgibt.`);
    return ok(html`🎉 Perfekt! Dein Spiel erkennt Siege <em>und</em> Unentschieden — ein vollständiges Tic-Tac-Toe!`);
  } catch (e) {
    return err(html`Dein Code lässt sich nicht ausführen: ${e.message}`);
  }
}

function rerun() {
  const code = editor.value;
  const stripped = stripModuleSyntax(code);
  runTestCasesWithTimeout({ code: stripped, fnName: "isDraw", cases: DRAW_CASES })
    .then(r => isDrawSlot.replaceChildren(testReport(r, "isDraw", { summaryOnly: true })));
  runTestCasesWithTimeout({ code: stripped, fnName: "isVictory", cases: VICTORY_CASES })
    .then(r => isVictorySlot.replaceChildren(testReport(r, "isVictory", { summaryOnly: true })));
  endIfSlot.replaceChildren(endIfReport(code));
  boardSlot.replaceChildren(gameBoard(code, {
    showState: true,
    hint: "Gewinne mit drei in einer Reihe oder füll das ganze Feld für ein Unentschieden — das Spiel sollte jetzt enden."
  }));
  feedbackSlot.replaceChildren(capstone(code));
}
mountEditor({ editor });
const section = mountGameSection({
  nodes: [
    sectionLabel("Test: isDraw"), isDrawSlot,
    sectionLabel("Test: isVictory"), isVictorySlot,
    sectionLabel("Test: endIf"), endIfSlot,
    sectionLabel("Dein Spiel"), boardSlot,
    sectionLabel("Übung"), feedbackSlot
  ],
  onRun: () => { const b = editor.querySelector(".run-button"); if (b) b.click(); }
});
editor.addEventListener("input", () => { rerun(); section.expand(); });
rerun();
return {editor,isDrawSlot,isVictorySlot,endIfSlot,boardSlot,feedbackSlot,DRAW_CASES,VICTORY_CASES,ENDIF_CASES,endIfReport,capstone,rerun,section};
},
    inputs: ["codeEditor","starter","html","loadGame","err","hint","testReport","makeClient","ok","stripModuleSyntax","runTestCasesWithTimeout","gameBoard","mountEditor","mountGameSection","sectionLabel"],
    outputs: ["editor","isDrawSlot","isVictorySlot","endIfSlot","boardSlot","feedbackSlot","DRAW_CASES","VICTORY_CASES","ENDIF_CASES","endIfReport","capstone","rerun","section"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
